import React, { useMemo, useEffect } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import { useAuthContext } from 'src/auth/hooks';
import { isAllowedTo } from 'src/services/util';
import { PrivilegeType } from 'src/services/role';

type Props = {
  type: PrivilegeType | PrivilegeType[];
  requireWrite?: boolean;
  children: React.ReactNode;
};

// This component is meant to be used everywhere a restriction based on user permission is needed
const Restricted: React.FunctionComponent<Props> = ({ type, requireWrite, children }) => {
  const router = useRouter();
  const { user } = useAuthContext();
  const isAllowed = useMemo(() => {
    if (Array.isArray(type)) {
      return !!type.filter((item) => isAllowedTo(item, user?.permissions, requireWrite)).length;
    }
    return isAllowedTo(type, user?.permissions, requireWrite);
  }, [requireWrite, type, user?.permissions]);
  useEffect(() => {
    if (!isAllowed) {
      if (requireWrite) {
        router.push(paths.page403);
      } else {
        router.push(paths.page404);
      }
    }
  }, [isAllowed, router, requireWrite]);
  if (isAllowed) {
    return <>{children}</>;
  }

  return <></>;
};

export default Restricted;
